"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const WidgetUtil_1 = require("../util/WidgetUtil");
const GlobalCounter_1 = tslib_1.__importDefault(require("../util/GlobalCounter"));
const GlobalCustomElementProps_1 = tslib_1.__importDefault(require("../util/GlobalCustomElementProps"));
class WidgetCustomElement extends HTMLElement {
    constructor(props) {
        super();
        if (!this.dataset.propsId) {
            this.dataset.propsId = GlobalCounter_1.default.next();
        }
        if (props) {
            this.setProps(props);
        }
        else {
            this.props = GlobalCustomElementProps_1.default.getProps(this.dataset.propsId);
        }
    }
    setProps(props) {
        this.props = props;
        if (this.dataset.propsId) {
            GlobalCustomElementProps_1.default.setProps(this.dataset.propsId, this.props);
        }
    }
    clearHTMLChildren() {
        while (this.firstChild) {
            this.removeChild(this.firstChild);
        }
    }
    setVisible(visible, retainPlacement = false) {
        (0, WidgetUtil_1.setElementVisible)(this, visible, retainPlacement);
    }
    isVisible() {
        return (0, WidgetUtil_1.isElementVisible)(this);
    }
    removeFromParent() {
        this.parentElement?.removeChild(this);
    }
    /**
     * Check whether the element is attached to the dom
     * @param element {Element} the element to check
     */
    isAttached(element) {
        return this.isConnected;
    }
}
exports.default = WidgetCustomElement;
//# sourceMappingURL=WidgetCustomElement.js.map